import React, { useEffect, useState } from 'react';
import { Purchases } from '@revenuecat/purchases-capacitor';

const Paywall = ({ onPurchaseSuccess, onClose }) => {
    const [offerings, setOfferings] = useState(null);
    const [isPro, setIsPro] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const setup = async () => {
            try {
                // 获取用户信息，检查是否已经是 Pro
                const customerInfo = await Purchases.getCustomerInfo();
                console.log("返回结果的所有Key:", Object.keys(customerInfo)); 
                console.log("返回结果的字符串详情:", JSON.stringify(customerInfo));                
                if (customerInfo.customerInfo.entitlements.active['lezhiyi-tech Pro']) {
                    setIsPro(true);
                }

                // 获取后台配置的 Offering
                const offeringsData = await Purchases.getOfferings();
                console.log("当前offeringsData",offeringsData);
                if (offeringsData.current !== null && offeringsData.current.availablePackages.length !== 0) {
                    setOfferings(offeringsData.current);
                }
            } catch (e) {
                console.error("初始化支付失败", e);
            } finally {
                setLoading(false);
            }
        };

        setup();
    }, []);

    // 执行购买动作
    const handlePurchase = async (pkg) => {
        try {
            setLoading(true);
            const { customerInfo } = await Purchases.purchasePackage({ aPackage: pkg });

            // 检查购买后的权益，直接更新前端显示
            if (customerInfo.entitlements.active['lezhiyi-tech Pro']) {
                setIsPro(true);
                // 通知父组件（直接更新本地状态，不查询后端）
                onPurchaseSuccess?.();
                // 关闭弹窗
                onClose?.();
            }
        } catch (e) {
            if (!e.userCancelled) {
                alert("购买过程中发生错误: " + e.message);
            }
        } finally {
            setLoading(false);
        }
    };

    // 恢复购买
    const restorePurchases = async () => {
        try {
            const customerInfo = await Purchases.restorePurchases();
            if (customerInfo.entitlements.active['lezhiyi-tech Pro']) {
                setIsPro(true);
                onPurchaseSuccess?.();
                onClose?.();
            } else {
                alert("未发现可恢复的权益。");
            }
        } catch (e) {
            alert("恢复失败: " + e.message);
        }
    };

    if (loading) return <div>加载商品中...</div>;

    if (isPro) return <div>✨ 您已是 Pro 会员，享受所有特权！</div>;

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>升级到 Pro</h2>
            <p>解锁所有高级功能</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '20px' }}>
                {offerings && offerings.availablePackages.map((pkg) => (
                    <button
                        key={pkg.identifier}
                        onClick={() => handlePurchase(pkg)}
                        style={{
                            padding: '15px',
                            borderRadius: '10px',
                            border: '1px solid #ddd',
                            backgroundColor: '#fff',
                            cursor: 'pointer'
                        }}
                    >
                        <div style={{ fontWeight: 'bold' }}>{pkg.packageType}</div>
                        <div style={{ color: '#007aff' }}>{pkg.product.priceString}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>{pkg.product.description}</div>
                    </button>
                ))}
            </div>

            <button onClick={restorePurchases} style={{ marginTop: '20px', fontSize: '12px', background: 'none', border: 'none', color: '#999', textDecoration: 'underline' }}>
                恢复购买
            </button>
        </div>
    );
};

export default Paywall;